import * as React from 'react';
import * as styles from './Row.css';

export const Row: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['flex-row']}>{children}</div>;
};
